import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingTemplate from '../templates/LandingTemplate';
import SEO from '../atoms/SEO';
import { useChat } from '../../context/ChatContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { 
    setPdfContent, 
    setTechRequirementsContent, 
    interviewType, 
    setInterviewTypeMode 
  } = useChat();

  const handleStartClick = () => {
    if (interviewType === 'technical') {
      navigate('/technical-chat');
    } else {
      navigate('/chat');
    }
  };

  const handlePdfTextExtracted = (text) => {
    setPdfContent(text);
  };

  const handleTechTextSubmitted = (text) => {
    setTechRequirementsContent(text);
  };

  const handleInterviewTypeChange = (type) => {
    setInterviewTypeMode(type);
  };

  return (
    <>
      <SEO 
        title="Welcome" 
        description="Practice behavioral and technical interviews with our AI-powered interview coach!" 
      />
      <LandingTemplate 
        onStartClick={handleStartClick} 
        onPdfTextExtracted={handlePdfTextExtracted}
        onTechTextSubmitted={handleTechTextSubmitted}
        interviewType={interviewType}
        onInterviewTypeChange={handleInterviewTypeChange}
      />
    </>
  );
};

export default LandingPage; 